import React from 'react'

import { TextField } from '@nike/eds'
import { Search } from '@nike/nike-design-system-icons'

type GlobalFilterProps = {
  globalFilter: string
  handleGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function GlobalFilter({ globalFilter, handleGlobalFilterChange }: GlobalFilterProps) {
  return (
    <TextField
      id='table--global-filter'
      className='table-global-search' // *NOTE: global classname if needed to override
      type='text'
      label=''
      placeholder='Search...'
      beforeSlot={<Search />}
      value={globalFilter || ''}
      onChange={handleGlobalFilterChange}
      hideLabel
    />
  )
}
